import { useStaticQuery, graphql } from 'gatsby'

const Data = () => {
  const {
    senadores,
    senadoresEnEjercicio,
    diputados,
    preguntas,
    respuestasDiputados,
    respuestasSenadores,
    respuestasSenadoresEnEjercicio,
  } = useStaticQuery(graphql`
    {
      senadores: allGoogleSenadoresSheet(
        filter: { elegido: { eq: "Electo" } }
      ) {
        nodes {
          id
          nombre
          circunscripcion: circunscripci_n
          lista
          numerocandidato: n_meroCandidato
          letralista: letraLista
          fechaRespuestaCuestionario
          partidoPolitico: partidoPol_tico__siCorresponde_
          profesion: profesi_nUOficio
          sexo
          nivelEducacional
          rangoDeEdad
        }
      }

      senadoresEnEjercicio: allGoogleSenadoresAntiguosSheet {
        nodes {
          id
          nombre
          circunscripcion: circunscripci_n
          lista
          fechaRespuestaCuestionario
          partidoPolitico: partidoPol_tico__siCorresponde_
          profesion: profesi_nUOficio
          sexo
          nivelEducacional
          rangoDeEdad
        }
      }

      diputados: allGoogleDiputadosSheet(
        filter: { elegido: { eq: "Electo" } }
      ) {
        nodes {
          id
          nombre
          distrito
          lista
          numerocandidato: n_meroCandidato
          letralista: l
          fechaRespuestaCuestionario
          partidoPolitico: partidoPol_tico__siCorresponde_
          profesion: profesi_nUOficio
          sexo
          nivelEducacional
          rangoDeEdad
        }
      }
      preguntas: allGooglePreguntasSheet {
        nodes {
          id
          numero: n_mero
          enunciado
          sobreEstaPregunta
          campoEnPlanilla
          consideradaEnMapa
          orden
          slug
        }
      }
      respuestasSenadores: allGoogleRespuestasSenadoresSheet(
        filter: { _1: { ne: "#N/A" } }
      ) {
        nodes {
          _1
          _2
          _3
          _4
          _5
          _6
          _7
          _8
          _9
          _10
          _11
          _12
          _13
          _14
          _15
          _16
          nombre
        }
      }
      respuestasSenadoresEnEjercicio: allGoogleRespuestasSenadores2018Sheet(
        filter: { _1: { ne: "#N/A" } }
      ) {
        nodes {
          _1
          _2
          _3
          _4
          _5
          _6
          _7
          _8
          _9
          _10
          _11
          _12
          _13
          _14
          _15
          _16
          nombre
        }
      }
      respuestasDiputados: allGoogleRespuestasDiputadosSheet(
        filter: { _1: { ne: "#N/A" } }
      ) {
        nodes {
          _1
          _2
          _3
          _4
          _5
          _6
          _7
          _8
          _9
          _10
          _11
          _12
          _13
          _14
          _15
          _16
          nombre
        }
      }
    }
  `)
  return {
    senadores,
    diputados,
    senadoresEnEjercicio,
    preguntas,
    respuestasDiputados,
    respuestasSenadores,
    respuestasSenadoresEnEjercicio,
  }
}

export default Data
